// if only one assertion function needed then not worth creating a package for it
export function assert(condition: unknown, message?: string): asserts condition {
  if (!condition) {
    // tip: put breakpoint here in development
    throw new AssertionError(message);
  }
}

export class AssertionError extends Error {
  constructor(...params: Parameters<typeof Error>) {
    super(...params);

    this.name = "AssertionError";

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AssertionError);
    }
  }
}
